'use client'
import {
  Thead
} from "./chunk-DRZNIHMG.mjs";
import {
  Tr
} from "./chunk-GIQFRSD6.mjs";
import {
  TableCaption
} from "./chunk-V3K6UINC.mjs";
import {
  TableContainer
} from "./chunk-OA6OURRG.mjs";
import {
  Tbody
} from "./chunk-J4QO5GAJ.mjs";
import {
  Td
} from "./chunk-T2WCTPDH.mjs";
import {
  Tfoot
} from "./chunk-B5H2YLEF.mjs";
import {
  Th
} from "./chunk-MGVPL3OH.mjs";
import {
  Table,
  useTableStyles
} from "./chunk-GEJVU65N.mjs";
export {
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  useTableStyles
};
//# sourceMappingURL=index.mjs.map